export default "__VITE_ASSET__BpMCgR0I__"